import { createAction } from '@reduxjs/toolkit';

import type { SubmitActions } from '@/modules/forms';

import type { SecretFormValues } from '../../schemas';
import type { Secret } from '../../types';
import types from '../actionTypes';

export const updateSecret = createAction(
    types.UPDATE_SECRET,
    (id: Secret['id'], values: SecretFormValues, actions: SubmitActions<SecretFormValues>) => ({
        payload: values,
        meta: { id, ...actions },
    }),
);

export const updateSecretSuccess = createAction(types.UPDATE_SECRET_SUCCESS, (id: Secret['id']) => ({
    meta: { id },
    payload: undefined,
}));

export const updateSecretFailure = createAction(types.UPDATE_SECRET_FAILURE, (id: Secret['id'], error: any) => ({
    meta: { id },
    payload: undefined,
    error,
}));

export const updateSecretReset = createAction(types.UPDATE_SECRET_RESET, (id: Secret['id']) => ({
    meta: { id },
    payload: undefined,
}));
